import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { mockContact } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-orange-400 bg-clip-text text-transparent">
              IDROMO
            </div>
            <p className="text-sm text-gray-400">
              Idraulica e ristrutturazioni professionali a Modena. Giovani, appassionati e precisi.
            </p>
          </div>

          {/* Servizi */}
          <div>
            <h3 className="font-bold text-white mb-4">Servizi</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#servizi" className="hover:text-blue-400 transition-colors">Impianti Idraulici</a></li>
              <li><a href="#servizi" className="hover:text-blue-400 transition-colors">Irrigazione</a></li>
              <li><a href="#servizi" className="hover:text-blue-400 transition-colors">Caldaie</a></li>
              <li><a href="#servizi" className="hover:text-blue-400 transition-colors">Ristrutturazioni</a></li>
              <li><a href="#servizi" className="hover:text-blue-400 transition-colors">Pronto Intervento</a></li>
            </ul>
          </div>

          {/* Link Rapidi */}
          <div>
            <h3 className="font-bold text-white mb-4">Link Rapidi</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#servizi" className="hover:text-blue-400 transition-colors">I Nostri Servizi</a></li>
              <li><a href="#chi-siamo" className="hover:text-blue-400 transition-colors">Chi Siamo</a></li>
              <li><a href="#recensioni" className="hover:text-blue-400 transition-colors">Recensioni</a></li>
              <li><a href="#contatti" className="hover:text-blue-400 transition-colors">Contatti</a></li>
            </ul>
          </div>

          {/* Contatti */}
          <div>
            <h3 className="font-bold text-white mb-4">Contatti</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-1 flex-shrink-0 text-blue-400" />
                <a href={`tel:${mockContact.phone}`} className="hover:text-blue-400 transition-colors">
                  {mockContact.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-1 flex-shrink-0 text-orange-400" />
                <a href={`mailto:${mockContact.email}`} className="hover:text-orange-400 transition-colors">
                  {mockContact.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-blue-400" />
                <span>{mockContact.city} e Provincia</span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex gap-3 mt-6">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-orange-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>© {currentYear} Idromo Italia. Tutti i diritti riservati.</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-blue-400 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-blue-400 transition-colors">Cookie Policy</a>
              <a href="#" className="hover:text-blue-400 transition-colors">Termini di Servizio</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
